import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@shared/ui/card';
import { LabeledInput, LoadingButton } from '@shared/patterns';
import { useAuth } from '@shared/auth/AuthContext';
import { ApiError } from '@shared/api/client';

export const LoginForm: React.FC = () => {
  const [email, setEmail] = useState('ceo');
  const [password, setPassword] = useState('2026');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);

    try {
      await login(email, password);
      const next = searchParams.get('next');
      if (next && next.startsWith('/') && !next.startsWith('//')) {
        navigate(next, { replace: true });
      } else {
        navigate('/core/contacts', { replace: true });
      }
    } catch (err: unknown) {
      if (err instanceof ApiError) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('An unexpected login error occurred.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Account Authentication</CardTitle>
        <CardDescription>Enter your credentials to access tenant suites.</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="p-3 rounded-md bg-destructive/15 border border-destructive/30 text-xs text-destructive font-medium">
              {error}
            </div>
          )}
          <LabeledInput
            label="Username or Email"
            type="text"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ceo"
          />
          <LabeledInput
            label="Password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <LoadingButton type="submit" className="w-full" isLoading={isSubmitting}>
            Sign In
          </LoadingButton>
        </form>
      </CardContent>
    </Card>
  );
};
